import { createTable } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 2,
  steps: [
    createTable({
      name: 'messages',
      columns: [
        { name: 'chat_id', type: 'string', isIndexed: true },
        { name: 'connection_key', type: 'string' },
        { name: 'phone_number', type: 'string' },
        { name: 'title', type: 'string', isOptional: true },
        { name: 'text', type: 'string' },
        { name: 'name', type: 'string' },
        { name: 'message_id', type: 'string' },
        { name: 'media_id', type: 'number', isOptional: true },
        { name: 'at', type: 'number' },
        { name: 'status', type: 'string' },
        { name: 'source', type: 'string' },
        { name: 'style', type: 'string' },
        { name: 'user_id', type: 'string', isOptional: true },
        { name: 'user_name', type: 'string', isOptional: true },
        { name: 'medias', type: 'string', isOptional: true },
        { name: 'status_details', type: 'string' }
      ]
    })
  ]
}
